export const editPlanText = {
    en:{
        s: "Change my plan",
        h1: "Want something else?",
        h2: "• No problem.",
        h3: "• Solve the Pre‑plan intake, start again with something else.",
        txt1: "For now only one plan at a time is available. It's our priority to make more plans per user. Therefore, if you have different problems please be patient and start with one session plan.",
        txt2: "If you belive that you achived wanted results you can solve the Pre-plan intake again for other problems. You can repeat this as many times as you want. Your progress in the last plan will be saved. You can still see your done sessions for each day in a calendar.",
        solvePPI: "Solve the Pre-plan intake",
        PPI: "Pre-plan intake",
        costumPlan: "Enter costum plan code: ",
    },
    sl: {
        s: "Spremeni moj načrt",
        h1: "Si želiš nekaj drugega?",
        h2: "- Ni problema.",
        h3: "- Izpolni uvodni vprašalnik in začni znova z drugim ciljem.",
        txt1: "Trenutno lahko uporabljaš le en načrt naenkrat. Naš cilj je omogočiti več načrtov hkrati, zato te prosimo za malo potrpljenja – za zdaj začni z enim načrtom.",
        txt2: "Če meniš, da si dosegel želene rezultate, lahko ponovno izpolniš uvodni vprašalnik za druge izzive. To lahko ponoviš kolikorkoli krat želiš. Napredek iz prejšnjega načrta se bo shranil, opravljene aktivnosti pa lahko še vedno spremljaš v koledarju.",
        solvePPI: "Izpolni uvodni vprašalnik",
        PPI: "Uvodni vprašalnik",
        costumPlan: "Vnesite kodo prilagojenega plana: "
    },
} as const;

export const todaysSessionText = {
    en: {
        s: "Today's Sessions",
        todayPlan1: "Plan for today",
        todayPlan2: "No more sessions for today",
        activeSess1: "Complete the remaining sessions below.",
        activeSess2: "All today’s sessions are completed.",
        noPlan: "No active plan assigned to the user.",
        failPlan: "Failed to load today's plan.",
        noScheduled: "No sessions scheduled for today.",
        date: "Date:",


        hName: "Exercise Name:",
        hDifficulty: "Difficulty:",
        hNofSets: "Number of sets:",
        hTime: "Estimated Time:",
    },
    sl: {
        s: "Današnje vadbe",
        todayPlan1: "Načrt za danes",
        todayPlan2: "Za danes ni več vadb",
        activeSess1: "Dokončaj preostale vadbe spodaj.",
        activeSess2: "Vse današnje vadbe so zaključene.",
        noPlan: "Ni aktivnega plana, ki bi bil predpisan uporabniku.",
        failPlan: "Napaka pri nalaganju današnjega plana.",
        noScheduled: "Danes ni predpisanih nobenih vaj.",
        date: "Datum:",

        hName: "Ime vaje:",
        hDifficulty: "Težavnost:",
        hNofSets: "Število serij:",
        hTime: "Predviden čas:",

    }
} as const;

export const costumDateText = {
    en: {
        s: "Day's Sessions:",
        todayPlan1: "Sessions done on",
        todayPlan2: "No more sessions for this day",
        activeSess1: "Complete the remaining sessions below.",
        activeSess2: "All the day's sessions are completed.",

        hName: "Exercise Name:",
        hDifficulty: "Difficulty:",
        hNofSets: "Number of sets:",
        hTime: "Estimated Time:",
    },
    sl: {
        s: "Vadbe na dan: ",
        todayPlan1: "Načrt za ",
        todayPlan2: "Za ta dan ni več vadb",
        activeSess1: "Dokončaj preostale vadbe spodaj.",
        activeSess2: "Vse vadbe za ta dan so zaključene.",
        hName: "Ime vaje:",
        hDifficulty: "Težavnost:",
        hNofSets: "Število serij:",
        hTime: "Predviden čas:",
    }
} as const;

export const unknownExercisesText = {
    en: {
        s: "Unknown Exercises:",
        t1: "The best place to learn new moves!",
        t2: "• Get to know it!",
        t3: "• Understand first, execute later!",
        desc: "Before each exercise is added to your sessions, we would like to present it to you. This way, you can become familiar with the specifics of each exercise and understand both its meaning and importance.",
        noNew: "No new exercises right now.",

    },
    sl:{
        s: "Neznane vaje:",
        t1: "Najboljše mesto za učenje novih vaj!",
        t2: "- Spoznaj jo!",
        t3: "- Najprej razumi, nato izvedi!",
        desc: "Preden vajo vključimo v tvoje vadbe, ti jo želimo predstaviti. Tako se lahko seznaniš z njenimi posebnostmi ter razumeš njen namen in pomembnost.",
        noNew: "Ni novih, neznanih vaj."
    },
} as const;

export const historyText = {
    en: {
        s: "My history",
        t: "Here you can see all your past sessions.",
        desc1: "Click on any of the sessions to see what you did and when you did it. The sessions are grouped by the dates. ",
        desc2: "You can search sessions by date if you click on desired day in the calender.",
        gj: "Good job, you spent",
        exe: "exercising!",
        history: "Brief history",
        complSess: "Completed sessions:",
        complSets: "Completed sets:",
        Tspent: "Total time spent:",
        fSessOn: "First session on:",
        sessHistory: "Session history",
        diff: "Difficulty:",
        sets: "Sets:"
    },
    sl: {
        s: "Moja zgodovina",
        t: "Tukaj lahko vidiš vse svoje pretekle vadbe.",
        desc1: "Klikni na katerokoli vadbo, da vidiš, kaj si delal in kdaj. Vadbe so razvrščene po datumih.",
        desc2: "Vadbe lahko poiščeš po datumu tako, da v koledarju izbereš želeni dan.",
        gj: "Odlično, porabil si",
        exe: "za vadbo!",
        history: "Kratek pregled",
        complSess: "Zaključene vadbe:",
        complSets: "Opravljene serije:",
        Tspent: "Skupni čas:",
        fSessOn: "Prva vadba:",
        sessHistory: "Zgodovina vadb",
        diff: "Težavnost:",
        sets: "Serije:"
    },
} as const;

export const exeNotiText = {
    en: {
        noti_title: "See all your read, unread, and past notifiactions in one place.",
        noti: "notifications:",
        btn_select: "Select",
        btn_cancel: "Cancel",
        btn_diselectAll: "Diselect All",
        btn_selectAll: "Select All",
        delet: "Delet",

        s_exe: "exercises:",
        t_exe: "Your Exercises:",


    },
    sl: {
        noti_title: "Na enem mestu si oglejte vsa svoja prebrana, neprebrana in pretekla obvestila.",
        noti: "obvestila:",
        btn_select: "Izberi",
        btn_cancel: "Prekliči",
        btn_diselectAll: "Prekliči izbiro vseh",
        btn_selectAll: "Izberi vse",
        delet: "Izbriši",

        s_exe: "vaje:",
        t_exe: "Vaše vaje:",


    },
} as const;